import { render } from "./AnnouncementView.vue?vue&type=template&id=40d7fc70"
import script from "./AnnouncementView.vue?vue&type=script&lang=js"
export * from "./AnnouncementView.vue?vue&type=script&lang=js"

import exportComponent from "/home/user_ui/taichung_main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__